import React from 'react';
import { observer, inject, PropTypes as MPropTypes } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Center } from 'legacyComponents/styled/lib';

import Header from 'apps/components/header/header';

import Button from 'components/Button';

@withNamespaces()
@inject('routerStore')
@observer
export class FeaturesPage extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div>
          <Center>
            <Link name='home.signIn'>
              <Button text='Get started for free' />
            </Link>
          </Center>
        </div>
      </>
    );
  }
}

FeaturesPage.propTypes = {
  t: PropTypes.func,
  params: MPropTypes.observableMap,
};
